<template>
<div>
  <add-heading :title="this.$t('widget.openJobs')" v-on:add="onLabelAction" :label="label" :stepped="false" />
  <div v-if="jobs && jobs.length > 0 ">
    <row-card class="job-card"
      v-for="(job) in jobs" :key="job.id"
      :imageUrl="companyImage(job)" :leftTitle="job.title"
      :rightTitle="salary(job)"
      :rightSubtitle="job.contract"
      @click="onCardClicked(job)">
      <template slot="leftSubtitle">
        <job-locations :locations="job.locations" :remote="job.isRemoteAvailable">
        </job-locations>
      </template>
    </row-card>
  </div>
  <empty-state v-else :title="this.$t('widget.noJobs')" icon="empty-state-eyes" >
    <template slot="content">
      <p class="text">{{this.$t('widget.thereNoJobs')}}</p>
    </template>
  </empty-state>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import AddHeading from '@/components/general/add-heading'
import RowCard from '@/components/general/row-card'
import JobSalary from '@/components/general/job-salary'
import JobLocations from '@/components/jobs/job-locations'
import EmptyState from '@/components/general/empty-state'
import _ from 'lodash'

export default {
  components: { AddHeading, RowCard, EmptyState, JobSalary, JobLocations },
  props: {
    company: {
      type: Object,
      default: () => null
    },
    isViewer: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // async company (newVal) {
    //   if (newVal) {
    //     await this.getJobs(_.get(newVal, 'companyId') || _.get(newVal, 'id'))
    //   }
    // }
  },
  computed: {
    ...mapState('companies', [
      'jobs'
    ]),
    getCompanyId () {
      return _.get(this.company, 'companyId') || _.get(this.company, 'id')
    },
    label () {
      return this.isViewer ? '' : 'New'
    },
    isWidget () {
      return !!this.$route.meta.hasOwnProperty('widgetMode')
    }
  },
  methods: {
    ...mapActions('companies', [
      'getJobs', 'getPublishedJobs'
    ]),
    ...mapMutations('companies', [
      'resetJobs'
    ]),
    salary (job) {
      return JobSalary.methods.salary(job)
    },
    onLabelAction (job) {
      if (this.isViewer) {
        this.$router.push('/admin/jobs')
      } else {
        this.$router.push('/admin/jobs')
      }
    },
    onCardClicked (job) {
      if (this.isWidget) {
        this.$router.push(`/widget/jobs/${job.id}`)
      } else {
        this.$router.push(`/jobs/${job.id}`)
      }
    },
    companyImage (job) {
      return job.companyImageUrl || `/api/identicons/${this.company.id || this.company.companyId}`
    }
  },
  async mounted () {
    await this.getPublishedJobs(this.getCompanyId)
  },
  beforeDestroy () {
    this.resetJobs([])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.card.job-card {
  cursor: pointer;
}

.card.job-card:hover {
  background-color: $hover-background;
}

.card.job-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.job-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/hirer/open-jobs-section.vue